export default __webpack_public_path__ + "static/media/team-4@2x.f97e3d62.png";